import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import async from 'async';
import Icon from '@material-ui/core/Icon';
import { UiHelper } from '../common/helpers/UiHelper';
import { ApiHelper } from '../common/helpers/ApiHelper';
import { Helper } from '../common/helpers/Helper';
import { ExcelDocUploader } from '../common/components/ExcelDocUploader';
import { CustomDialog } from '../components/CustomDialog';
import { CustomFormFieldsDialogV2 } from '../components/CustomFormFieldsDialogV2';
import { ActionHeaderbar } from '../components/ActionHeaderbar';
import { PopOverV2 } from '../components/PopOverV2';
import { TableListV2 } from '../components/TableListV2';
import { Stats } from '../components/Stats';
import { Controller } from '../common/Controller';
import { CommonStyles } from '../styles/Styles';
import { AppTheme } from '../styles/AppTheme';
import { AppConfig } from '../AppConfig';
import { appData } from '../data/AppData';

export class Users extends Component {
  constructor(props) {
    super(props);
    this.orgId = (this.props.match && this.props.match.params) ? this.props.match.params.id : null
    this.responseByKey = {}
    this.cams = []
    this.places = []
    this.orgView = (this.props.match && this.props.match.url === '/orgs/' + this.orgId) ? true : false
    this.state = {
      updateMemberDialog: false,
      verifyMemberDialog: false,
      bulkUserUploadDialog: false,
      dialogAction: '',
      dialogTitle: '',
      selectedItem: {},
      anchorEl: null,
      confirmDeleteView: false,
      inProcess: false,
      fetchState: ApiHelper.State.LOADING,
    }
  }

  componentDidMount() {
    if (this.orgView) {
      this.fetchItemsForOrgView()
    } else {
      this.fetchItems();
    }
  }

  fetchItems = () => {
    const queryParams = { orgId: this.orgId }
    async.parallel(
      [
        function (callback) {
          ApiHelper.call(
            { method: 'GET', endPoint: ApiHelper.makeUrlPath(['users'], queryParams) }, callback)
        }
      ],
      function (err, results) {
        if (err) {
          this.setState({
            fetchState: ApiHelper.State.ERROR,
            errMsg: Helper.getErrorMsg(err)
          })
          return
        }

        this.org = Controller.get().userMgr().getCurrentOrg()

        for (const item of results[0]) {
          if (item.orgs && item.orgs.length > 0) {
            item.role = item.orgs[0].roles
          }
        }

        this.setState({
          users: results[0],
          fetchState: ApiHelper.State.READY
        })

      }.bind(this))
  }

  fetchItemsForOrgView = () => {
    const queryParams = { orgId: this.orgId }
    const orgId = this.orgId
    async.parallel(
      [
        function (callback) {
          ApiHelper.call(
            { method: 'GET', endPoint: ApiHelper.makeUrlPath(['users'], queryParams) }, callback)
        },
        function (callback) {
          ApiHelper.call(
            { method: 'GET', endPoint: ApiHelper.makeUrlPath(['orgs', orgId]) }, callback)
        },
        function (callback) {
          ApiHelper.call(
            { method: 'GET', endPoint: ApiHelper.makeUrlPath(['placesByOrgId'], queryParams) }, callback)
        },
      ],
      function (err, results) {
        if (err) {
          this.setState({
            fetchState: ApiHelper.State.ERROR,
            errMsg: Helper.getErrorMsg(err)
          })
          return
        }

        if (!results || results.length !== 3) {
          this.setState({
            fetchState: ApiHelper.State.ERROR,
            errMsg: Helper.getErrorMsg()
          })
          return
        }

        let totalCams = []
        for (const item of results[2]) {
          totalCams = totalCams.concat(item.cams)
        }

        this.cams = totalCams
        this.places = results[2]
        this.org = results[1]

        for (const item of results[0]) {
          if (item.orgs && item.orgs.length > 0) {
            item.role = item.orgs[0].roles
          }
        }
        this.setState({
          users: results[0],
          logoUrl: results[1].logoUrl,
          fetchState: ApiHelper.State.READY
        })
      }.bind(this))
  }

  resetToDefaultValues = () => {
    this.responseByKey = {}
    this.setState({
      updateMemberDialog: false,
      verifyMemberDialog: false,
      bulkUserUploadDialog: false,
      inProcess: false,
      dialogAction: '',
      dialogTitle: '',
      selectedItem: {},
      anchorEl: null,
      confirmDeleteView: false,
    })
  }

  getRolesByOrgId = () => {
    delete this.responseByKey.cred
    if (this.responseByKey &&
      this.responseByKey.orgs) {
      for (const org of this.responseByKey.orgs) {
        if (org._id === this.orgId) {
          this.responseByKey.role = org.roles
        }
      }
    }
  }

  showAddMemberDialog = () => {
    this.setState({
      verifyMemberDialog: true,
      dialogTitle: 'Add a Member',
    })
  }

  showConfirmDeleteView = () => {
    this.setState({
      confirmDeleteView: true,
      inProcess: false
    })
  }

  showBulkUserUploadDialog = () => {
    this.setState({
      bulkUserUploadDialog: true,
      dialogTitle: 'Add multiple members'
    })
  }

  showDeleteMemberDialog = () => {
    this.responseByKey = this.state.selectedItem
    const thisObj = this
    this.verifyUser(function (err, result) {
      if (err) return
      thisObj.setState({
        anchorEl: null,
        updateMemberDialog: true,
        dialogTitle: 'Delete a Member',
        dialogAction: 'delete',
      })
    })
  }

  showUpdateMemberDialog = () => {
    this.responseByKey = this.state.selectedItem
    const thisObj = this
    this.verifyUser(function (err, result) {
      if (err) return
      thisObj.setState({
        anchorEl: null,
        updateMemberDialog: true,
        dialogTitle: 'Edit a Member',
        dialogAction: 'edit',
      })
    })
  }

  onPopOverClick = (key) => {
    if (key === 'edit') {
      this.showUpdateMemberDialog()
    } else if (key === 'delete') {
      this.showDeleteMemberDialog()
    }
  }

  editClick = (e, item) => {
    this.setState({
      anchorEl: e.currentTarget,
      selectedItem: item
    })
  }

  editClickClose = () => {
    this.setState({ anchorEl: null })
  }

  setValue = (value, key) => {
    this.responseByKey[key] = value
  }

  addMembers = (items) => {
    this.setState({
      inProcess: true
    })
    let user = {}
    const userData = []
    for (const item of items) {
      user = {
        email: item.email,
        org: {
          _id: this.orgId,
          roles: item.role
        },
        cred: 'test@123',//TODO: pwd hardcoded
        name: item.name,
        phone: item.mobile,
        vehicleNumbers: item.vehicleNumbers
      }
      Helper.removeNullValues(user)
      userData.push(user)
    }
    let options = {}
    options = {
      method: 'POST',
      endPoint: ApiHelper.makeUrlPath(['user']),
      jsonBody: {
        userData: userData,
        action: 'ADD_MULTIPLE'
      }
    }

    ApiHelper.call(options, function (err, data) {
      if (err) {
        const msg = err.message ? err.message : 'An error occurred, please try again. Contact customer care if problem persists.';
        this.setState({
          errMsg: msg,
          errCode: err.respCode,
          inProcess: false,
        })
        return
      } else {
        this.resetToDefaultValues()
        if (this.orgView) {
          this.fetchItemsForOrgView()
        } else {
          this.fetchItems();
        }
      }
    }.bind(this))
  }

  getUserData = () => {
    let userData = {}
    if (this.orgId === 'PRODUCT') {
      userData = {
        email: this.responseByKey.email,
        org: {
          _id: this.orgId,
          roles: ['ADMIN']
        },
        cred: this.responseByKey.cred,
        name: this.responseByKey.name,
        phone: this.responseByKey.phone,
      }
    } else {
      userData = {
        email: this.responseByKey.email,
        org: {
          _id: this.orgId,
          roles: this.responseByKey.role
        },
        cred: this.responseByKey.cred,
        name: this.responseByKey.name,
        phone: this.responseByKey.phone,
        vehicleNumbers: this.responseByKey.vehicleNumbers
      }
    }
    return userData
  }

  addMember = () => {
    this.setState({
      inProcess: true
    })

    let options = {}
    const userData = this.getUserData()
    const id = this.state.selectedItem ? this.state.selectedItem._id : null

    if (!id) {
      options = {
        method: 'POST',
        endPoint: ApiHelper.makeUrlPath(['user']),
        jsonBody: {
          userData: userData
        }
      }
    } else {
      const body = {
        userData: userData
      }
      if (this.responseByKey.cred && this.responseByKey.cred.length > 0) {
        body.userData.cred = this.responseByKey.cred
      }
      options = {
        method: 'PUT',
        endPoint: ApiHelper.makeUrlPath(['user', id]),
        jsonBody: body
      }
    }
    Helper.removeNullValues(options.jsonBody.userData)
    ApiHelper.call(options, function (err, data) {
      if (err) {
        const msg = err.message ? err.message : 'An error occurred, please try again. Contact customer care if problem persists.';
        this.setState({
          errMsg: msg,
          errCode: err.respCode,
          inProcess: false,
        })
        return
      } else {
        this.resetToDefaultValues()
        if (this.orgView) {
          this.fetchItemsForOrgView()
        } else {
          this.fetchItems();
        }
      }
    }.bind(this))
  }

  deleteMember = () => {
    const id = this.state.selectedItem ? this.state.selectedItem._id : null
    if (!id) {
      return
    }
    this.setState({
      inProcess: true
    })
    const options = {
      method: 'DELETE',
      endPoint: ApiHelper.makeUrlPath(['user', id], { orgId: this.orgId }),
    }
    ApiHelper.call(options, function (err, data) {
      if (err) {
        const msg = err.message ? err.message : 'An error occurred, please try again. Contact customer care if problem persists.';
        this.setState({
          errMsg: msg,
          errCode: err.respCode,
          inProcess: false,
        })
        return
      } else {
        this.resetToDefaultValues()
        if (this.orgView) {
          this.fetchItemsForOrgView()
        } else {
          this.fetchItems();
        }
      }
    }.bind(this))
  }

  verifyUser = (callback) => {
    this.setState({
      inProcess: true
    })

    ApiHelper.call(
      {
        method: 'GET',
        endPoint: ApiHelper.makeUrlPath(['users'],
          { orgId: this.orgId, email: this.responseByKey.email })
      },
      function (err, result) {
        if (err) {
          if (err.original && err.original.status === 404) {
            this.setState({
              inProcess: false,
            })
            this.setUser()
          } else {
            this.setState({
              errMsg: Helper.getErrorMsg(err)
            })
          }
          if (callback) callback(Helper.getErrorMsg(err))
          return
        }

        this.setState({
          inProcess: false
        })
        this.responseByKey = result
        this.getRolesByOrgId()
        return callback(null, result)
      }.bind(this))
  }

  setUser = (item) => {
    if (item) {
      this.setState({
        selectedItem: item,
        verifyMemberDialog: false,
        updateMemberDialog: true,
        dialogAction: 'edit',
        dialogTitle: 'Edit a Member',
      })
    } else {
      this.setState({
        selectedItem: item,
        verifyMemberDialog: false,
        updateMemberDialog: true,
        dialogAction: 'add',
        dialogTitle: 'Add a Member',
      })
    }
  }

  verifyUserSuccess = (responseByKey) => {
    this.responseByKey = responseByKey
    this.verifyUser((err, result) => {
      this.setUser(result)
    })
  }

  renderVerifyUserDialog = () => {
    const formFields = [appData.userFieldEmail.email]
    return (
      <CustomFormFieldsDialogV2
        onClose={this.resetToDefaultValues}
        dialogOpen={this.state.verifyMemberDialog}
        dialogTitle={this.state.dialogTitle}
        confirmDeleteView={false}
        errMsg={this.state.errMsg}
        inProcess={this.state.inProcess}
        action={'lookup'}
        formFields={formFields}
        responseByKey={this.responseByKey}
        enableValidation={this.state.dialogAction === 'delete' ? false : true}
        onSuccess={this.verifyUserSuccess}
        formDisabled={this.state.dialogAction === 'delete' ? true : false}>
      </CustomFormFieldsDialogV2>
    )
  }

  renderMemberDialog = () => {
    const formFields = []
    if (this.orgId === 'PRODUCT') {
      for (const key in appData.adminUserFields) {
        formFields.push(appData.adminUserFields[key])
      }
    } else {
      for (const key in appData.userFields) {
        formFields.push(appData.userFields[key])
      }
    }

    return (
      <CustomFormFieldsDialogV2
        onClose={this.resetToDefaultValues}
        dialogOpen={this.state.updateMemberDialog}
        dialogTitle={this.state.dialogTitle}
        confirmDeleteView={this.state.confirmDeleteView}
        inProcess={this.state.inProcess}
        selectedItem={this.state.selectedItem}
        deleteItem={() => this.deleteMember()}
        action={this.state.dialogAction}
        showConfirmDeleteView={this.showConfirmDeleteView}
        responseByKey={this.responseByKey}
        onSuccess={this.addMember}
        formFields={formFields}
        enableValidation={this.state.dialogAction === 'delete' ? false : true}
        formDisabled={this.state.dialogAction === 'delete' ? true : false}>
      </CustomFormFieldsDialogV2>
    )
  }

  onExcelValidationSuccess = (data) => {
    console.log('onValidationSuccess', data)
    this.addMembers(data)
  }

  renderBulkUserUploadDialog = () => {
    return (
      <CustomDialog
        onClose={this.resetToDefaultValues}
        disableBackdropClick={true}
        dialogOpen={this.state.bulkUserUploadDialog}
        dialogTitle={this.state.dialogTitle}
        inProcess={this.state.inProcess}>
        <div className={css(Styles.excelTipsOuterContainer)}>
          <div className={css(Styles.excelTipsContainer)}>
            <Icon fontSize={'small'} className={css(Styles.excelTipsIcon)}>info</Icon>
            <p className={css(Styles.excelTips)}>
              Please upload the file only in the specified format. You can download a sample file
              <a className={css(Styles.downloadLink)} href='https://uv-misc-test.s3.ap-south-1.amazonaws.com/org-members.xlsx'> here.</a> </p>
          </div>
          <div className={css(Styles.excelTipsContainer)}>
            <Icon fontSize={'small'} className={css(Styles.excelTipsIcon)}>info</Icon>
            <p className={css(Styles.excelTips)}>Uploading file in any other format will lead to failure of upload.</p>
          </div>
          <div className={css(Styles.excelTipsContainer)}>
            <Icon fontSize={'small'} className={css(Styles.excelTipsIcon)}>info</Icon>
            <p className={css(Styles.excelTips)}>For mobile entries, dial code should be given in the exact format as specified in our sample file</p>
          </div>

          <ExcelDocUploader
            uploadId={'contactList'}
            onExcelValidationSuccess={this.onExcelValidationSuccess}
          />
        </div>
      </CustomDialog>
    )
  }

  onRowItemClick = () => {
    return
  }

  render() {
    if (this.state.fetchState === ApiHelper.State.LOADING) {
      return UiHelper.componentLoadingView();
    } else if (this.state.fetchState === ApiHelper.State.ERROR) {
      return UiHelper.errorView(this);
    } else {
      return this.readyView();
    }
  }

  readyView = () => {
    const open = Boolean(this.state.anchorEl);
    const id = open ? 'simple-popover' : undefined;
    let orgName = null
    if (this.org && this.org.name === 'PRODUCT') {
      orgName = AppConfig.productName
    } else if (this.org) {
      orgName = this.org.name
    }

    return (
      <div className={css(CommonStyles.outerMainContainer)}>
        <ActionHeaderbar
          backPathName={(this.orgView && Controller.get().userMgr().isProductUser()) ? '/orgs' : null}
          title={orgName}
          items={this.state.users}
          statPrefix={'Team' + ((this.state.users && this.state.users.length > 1) ? ' Members' : ' Member')}
          buttonOneAction={this.showAddMemberDialog}
          buttonOneTitle={'ADD NEW MEMBER'}
          buttonTwoTitle={this.orgView ? 'Upload from excel' : null}
          buttonTwoAction={this.showBulkUserUploadDialog}
          inProcess={this.state.inProcess}
        />

        <div className={css(CommonStyles.innerMainContainer)}>
          <div className={css(Styles.innerMainContent)}>
            {this.orgView &&
              <Stats
                org={this.org}
                places={this.places}
                cams={this.cams}
                users={this.state.users}
              />
            }

            {this.state.users.length !== 0 &&
              <TableListV2
                disableRowClick={true}
                onRowItemClick={this.onRowItemClick}
                tableColumnTitles={window.innerWidth < 767 ? appData.userColMobileTitles : appData.userColDesktopViewTitles}
                tableColumnTitlesData={window.innerWidth < 767 ? appData.userColTitles : appData.userColDesktopViewTitles}
                items={this.state.users}
                editClick={this.editClick}
                id={id}
              />
            }

            {this.state.users.length === 0 &&
              <p className={css(CommonStyles.emptyView)}>No Members added yet</p>
            }
          </div>
        </div>

        {this.renderVerifyUserDialog()}

        {this.renderMemberDialog()}

        <PopOverV2
          id={id}
          open={open}
          items={appData.popOverFields}
          anchorEl={this.state.anchorEl}
          onPopOverClick={this.onPopOverClick}
          editClickClose={this.editClickClose}
        />

        {this.state.bulkUserUploadDialog &&
          this.renderBulkUserUploadDialog()
        }
      </div>
    )
  }
}

const Styles = StyleSheet.create({
  innerMainContent: {
    display: 'flex',
    width: '90%',
    flexDirection: 'column',
    margin: '40px 0px 50px 0px'
  },
  excelTips: {
    margin: 0,
    color: AppTheme.white,
  },
  excelTipsIcon: {
    marginRight: 5,
    color: AppTheme.white,
  },
  excelTipsContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    marginTop: 10,
    marginBottom: 10
  },
  excelTipsOuterContainer: {
    marginBottom: 10
  },
  downloadLink: {
    color: 'orange'
  }
})


// WEBPACK FOOTER //
// ./src/screens/Users.js